var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.512 10.61c5.906-2.823 9.844-4.683 11.814-5.582C19.952 2.46 21.121 2.015 21.883 2c.168-.003.542.042.785.259.205.182.261.428.288.601.027.173.06.567.034.875-.305 3.514-1.624 12.041-2.295 15.977-.284 1.665-.843 2.223-1.384 2.278-1.177.119-2.07-.853-3.21-1.672-1.782-1.282-2.79-2.08-4.52-3.331-2-1.446-.704-2.24.436-3.54.298-.34 5.482-5.511 5.582-5.98.012-.059.024-.278-.094-.393-.119-.116-.294-.076-.42-.045-.179.045-3.027 2.11-8.545 6.196-.808.609-1.54.905-2.197.89-.723-.017-2.114-.449-3.149-.818-1.268-.452-2.276-.691-2.189-1.46.046-.4.548-.809 1.507-1.227z",
    fill: "#29A9EB"
  })));
}
export default SvgTelegram;